import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useCurrentShopQuery = createQueryHook(ShopsApiClient.getCurrentShop, {
  queryKey: ['currentShop'],
  select: (data) => {
    data.name = decodeHtmlEntities(data.name)
    data.creatorName = decodeHtmlEntities(data.creatorName)
    data.description = decodeHtmlEntities(data.description)

    return data
  },
})
